import { isOfflineOnly } from './isOfflineOnly'

export const hasCloud = !isOfflineOnly && !!import.meta.env.VITE_HONO_URL